import { useAuthContext } from "../contexts/AuthContext";

/**
 * useAuth hook - provides authentication state and methods
 * This is a wrapper around AuthContext for backwards compatibility
 */
export const useAuth = () => {
  const auth = useAuthContext();

  return {
    // Backwards compatibility with old API
    data: auth.isAuthenticated,
    userId: auth.userId,
    access_token: auth.accessToken,
    isLoading: auth.isLoading,
    error: auth.error,
    // New API exposing more functionality
    user: auth.user,
    session: auth.session,
    isAuthenticated: auth.isAuthenticated,
    signOut: auth.signOut,
    refreshSession: auth.refreshSession,
  };
};

